import React, { Fragment } from "react"
import { formatDateAgo } from "../../../utils/date"
import BuildingCompany from "../../../ui/icons/solid/building-company"
import Link from "../../link"

const JOBS_URL = process.env.JOBS_URL || "https://jobs.sitepoint.com"

type JobCardProps = {
  title: string
  slug: string
  company_slug: string
  company_name: string
  job_type?: string
  publication_date: string
  location: string
  description: string
}

const JobCard = ({
  title,
  slug,
  company_slug,
  company_name,
  job_type,
  publication_date,
  location,
  description,
}: JobCardProps) => {
  const jobType = (job_type: string) => {
    switch (job_type) {
      case "full_time":
        return "Full Time"
      case "part_time":
        return "Part Time"
      case "internship":
        return "Internship"
      case "remote":
        return "Remote"
      default:
        return job_type
    }
  }
  return (
    <Link
      external
      to={`${JOBS_URL}/${company_slug}/${slug}/`}
      className="snap-center"
    >
      <div className="p-5 w-[328px] md:w-full rounded-2xl border border-neutral-alpha-4 hover:bg-neutral-alpha-2 flex flex-col gap-4">
        <div className="flex gap-6 justify-between">
          <div className="flex gap-1.5">
            <BuildingCompany className="shrink-0" />
            <span className="text-jar-3 font-medium text-neutral-alpha-12">
              {company_name}
            </span>
          </div>

          <p className="text-jar-3 text-neutral-1l shrink-0">
            {formatDateAgo(publication_date)}
          </p>
        </div>
        <div>
          <span className="text-jar-4 font-medium text-neutral-12 line-clamp-1">
            {title}
          </span>
          <p className="line-clamp-3 text-jar-3 text-neutral-11 mt-1">
            {description}
          </p>
        </div>
        <div className="flex gap-1.5 text-jar-3 font-medium text-neutral-12">
          <span>{location}</span>
          {job_type && (
            <Fragment>
              <span>·</span>
              <h2>{jobType(job_type)}</h2>
            </Fragment>
          )}
        </div>
      </div>
    </Link>
  )
}

export default JobCard
